/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Ai_AutoInputs */

const en_read_along_ai_auto = /** @type {(inputs: Read_Along_Ai_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic (recommended)`)
};

const es_read_along_ai_auto = /** @type {(inputs: Read_Along_Ai_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automático (recomendado)`)
};

/**
* | output |
* | --- |
* | "Automatic (recommended)" |
*
* @param {Read_Along_Ai_AutoInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_auto = /** @type {((inputs?: Read_Along_Ai_AutoInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_AutoInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_auto(inputs)
	return en_read_along_ai_auto(inputs)
});